(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welcome-to-your-new-hair"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Scroll progress bar
  var rafTicking = false;
  function updateProgress() {
    if (rafTicking) return;
    rafTicking = true;
    requestAnimationFrame(function() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? window.scrollY / docHeight : 0;
      document.documentElement.style.setProperty('--wnh-progress', progress.toFixed(4));
      rafTicking = false;
    });
  }
  if (document.querySelector('.wnh-progress')) {
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }
})();

(function() {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ----- Reveal observer -----
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-wnh-reveal]').forEach(function(el) { el.classList.add('is-visible'); });
    document.querySelectorAll('[data-count-to]').forEach(function(el) { el.textContent = el.getAttribute('data-count-to'); });
    return;
  }

  // ----- Count-up: prep -----
  var countEls = document.querySelectorAll('[data-count-to]');
  if (!reduceMotion) {
    countEls.forEach(function(el) { el.textContent = '0'; });
  }

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function animateCount(el, target, duration) {
    var start = performance.now();
    function frame(now) {
      var progress = Math.min((now - start) / duration, 1);
      el.textContent = Math.round(target * easeOutCubic(progress));
      if (progress < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  var revealIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');

      // Trigger count-ups within this revealed section
      if (!reduceMotion) {
        entry.target.querySelectorAll('[data-count-to]').forEach(function(el, i) {
          var target = parseInt(el.getAttribute('data-count-to'), 10);
          setTimeout(function() { animateCount(el, target, 1400); }, 350 + i * 180);
        });
      }
      revealIO.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  document.querySelectorAll('[data-wnh-reveal]').forEach(function(el) { revealIO.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
